
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_1dsep_9",
  "input": "awsui_input_2rhyz_1dsep_9",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_1dsep_22",
  "input-readonly": "awsui_input-readonly_2rhyz_1dsep_22",
  "root": "awsui_root_2rhyz_1dsep_35",
  "input-invalid": "awsui_input-invalid_2rhyz_1dsep_138",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_1dsep_147",
  "input-warning": "awsui_input-warning_2rhyz_1dsep_150",
  "input-type-search": "awsui_input-type-search_2rhyz_1dsep_162",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_1dsep_175",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1dsep_178",
  "input-has-no-border": "awsui_input-has-no-border_2rhyz_1dsep_178",
  "grouped": "awsui_grouped_2rhyz_1dsep_194",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_1dsep_200",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_1dsep_204",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_1dsep_210",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_1dsep_214",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_1dsep_218",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_1dsep_224",
  "input-container": "awsui_input-container_2rhyz_1dsep_229",
  "input-icon-start": "awsui_input-icon-start_2rhyz_1dsep_234",
  "input-icon-end": "awsui_input-icon-end_2rhyz_1dsep_241",
  "input-button-right": "awsui_input-button-right_2rhyz_1dsep_247",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_1dsep_251",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_1dsep_254",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_1dsep_258",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_1dsep_261",
  "inline-label": "awsui_inline-label_2rhyz_1dsep_251",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_1dsep_286",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_1dsep_311",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_1dsep_319",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_1dsep_332",
  "input-prefix": "awsui_input-prefix_2rhyz_1dsep_346",
  "input-suffix": "awsui_input-suffix_2rhyz_1dsep_347",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_1dsep_360",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_1dsep_369",
  "input-adorned": "awsui_input-adorned_2rhyz_1dsep_9"
};
  